export default "__VITE_PUBLIC_ASSET__1d643b53__"